import { useContext } from 'react'
import { TrashAlt } from '@styled-icons/boxicons-solid'

import Tooltip from '../../common/tooltip'
import { formatDateTime } from '../../../utils/common'
import { SELECT_TRACER_MAPPING, TracerMappingContext } from './context/context'
import Mappings from './Mappings'
import DropDownMenu from '../../common/DropDownMenu'

const TracerMappingRow = (props) => {
  const [state, dispatch] = useContext(TracerMappingContext)
  const isSelectedItem =
    `${props?.dtc}-${props?.acronym}` ==
    `${state?.selected_tracer_mapping?.dtc}-${state?.selected_tracer_mapping?.acronym}`

  return (
    <div key={`${props.dtc}-${props.acronym}`}>
      <div
        className={`w-full py-2 px-3 border-b border-b-gray text-black ${props.logs ? 'bg-green-400' : 'bg-white'}`}
      >
        <div className="flex flex-row w-full">
          <div className="flex w-3/12 pl-10 items-center table_text">
            <Tooltip position={'top'} message={props.dtc}>
              <div>{props.dtc}</div>
            </Tooltip>
          </div>
          <div className="flex w-4/12 pl-6 items-center table_text">
            <Tooltip position={'top'} message={props.description}>
              <div>{props.description}</div>
            </Tooltip>
          </div>
          <div className="w-2/12 pl-6 table_text">
            <Tooltip position={'top'} message={props.acronym}>
              <div>{props.acronym}</div>
            </Tooltip>
          </div>
          <div className="w-2/12 pl-6 table_text">
            <Tooltip
              position={'top'}
              message={props.updated_at ? formatDateTime(props.updated_at) : ''}
            >
              <div>
                {props.updated_at ? formatDateTime(props.updated_at) : ''}
              </div>
            </Tooltip>
          </div>
          <div className="flex w-1/12 pl-6 items-center pl-6">
            <div>
              {props.showAction ? (
                !isSelectedItem && (
                  <span
                    onClick={() => {
                      dispatch({ type: SELECT_TRACER_MAPPING, data: props })
                    }}
                    className={`cursor-pointer underline font-normal ${props.logs ? 'text-white' : 'text-blue-500'}`}
                  >
                    Review
                  </span>
                )
              ) : (
                <>
                  <span
                    onClick={() => {
                      props.onDelete()
                    }}
                    className="cursor-pointer p-2"
                  >
                    <TrashAlt size="2rem" color="#0189E9" />
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {isSelectedItem && (
        <div className={`bg-gray-300 border-b-gray`}>
          <div className="flex flex-row w-full font-medium border-b-gray pt-2">
            <div className="flex w-6/12 pl-6 items-center justify-between">
              <div>AT Mapping </div>
              {props.destination_only && (
                <div className={`font-bold text-sm pl-2 text-blue-500`}>
                  {' '}
                  ( Destination Only )
                </div>
              )}
              {
                <div className={`text-sm pl-2 text-blue-500`}>
                  [{formatDateTime(props?.at_mapping?.end[0]?.updated_at)}]
                </div>
              }
            </div>
            <div className="flex w-6/12  pl-2 items-center border-l-gray justify-between">
              Mapping From Tracer
              {props.tracer_destination_only && (
                <div className={`flex font-bold text-sm pl-2 text-blue-500`}>
                  ( Destination Only ){' '}
                </div>
              )}
              {props.logs ? (
                <div className="w-2/12 items-center pl-6">
                  <DropDownMenu
                    items={[
                      {
                        name: 'Success',
                        value: 'Success',
                        childrens: props?.logs?.success?.map(
                          (success, successIdx) => {
                            return { name: success }
                          }
                        ),
                      },
                      {
                        name: 'Errors',
                        value: 'Errors',
                        childrens: props?.logs?.errors?.map(
                          (error, errorIdx) => {
                            return { name: error }
                          }
                        ),
                      },
                    ]}
                    outsideClickClose={true}
                    onClick={() => {}}
                    width={`50vw`}
                  >
                    <span className="cursor-pointer underline font-normal text-green-500">
                      Logs
                    </span>
                  </DropDownMenu>
                </div>
              ) : (
                <div className="w-2/12 items-center pl-6">
                  <span
                    className="cursor-pointer underline font-normal text-green-500 font-bold"
                    onClick={() => {
                      props.TracerAction('accept')
                    }}
                  >
                    Accept
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-row w-full pb-4">
            <div className="w-6/12 pl-6 items-center py-2">
              <Mappings title={'Start'} mappings={props?.at_mapping?.start} />
              <Mappings title={'End'} mappings={props?.at_mapping?.end} />
              <Mappings
                title={'Devices'}
                mappings={props?.at_mapping?.devices}
              />
            </div>
            <div className="w-6/12 pl-2 items-center py-2 border-l-gray">
              {props.tracer_mappings.map((mapping, mappingIndex) => {
                return (
                  <div
                    className={`flex border-b-gray  ${mappingIndex % 2 !== 0 && 'pt-3'}`}
                    key={`tracer-mapping-${mappingIndex}`}
                  >
                    <div className="w-full items-center">
                      <Mappings
                        title={'Start'}
                        mappings={mapping?.start ? [mapping?.start] : []}
                      />
                      <Mappings
                        title={'End'}
                        mappings={mapping?.end ? [mapping?.end] : []}
                      />
                      <Mappings
                        title={'Devices'}
                        mappings={props?.tracer_mapping?.devices}
                        isOneLine={true}
                      />
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default TracerMappingRow
